<template>
    <Multiselect
        label="label"
        :value="selected"
        :options="options"
        :searchable="false"
        :show-labels="false"
        :disabled="!canRefine"
        @input="onChange"
    />
</template>

<script>
import { find } from 'lodash';
import Multiselect from 'vue-multiselect';

export default {
    components: {
        Multiselect
    },

    props: {
        items: {
            type: Array,
            required: true
        },
        canRefine: {
            type: Boolean,
            required: true
        },
        refine: {
            type: Function,
            required: true
        },
        placeholder: {
            type: String,
            default: 'All'
        }
    },

    data() {
        return {
            allOption: { label: this.placeholder, value: '' }
        };
    },

    computed: {
        selected() {
            return find(this.items, ['isRefined', true]) || this.allOption;
        },

        options() {
            return [this.allOption, ...this.items];
        }
    },

    methods: {
        onChange({ value }) {
            this.refine(value);
        }
    }
};
</script>

<style>
.multiselect {
    box-sizing: border-box;
    display: flex;
    flex-direction: row-reverse;
    height: 100%;
    min-height: unset;
    color: #001d02;
}

.multiselect--active,
.multiselect:hover {
    border-color: #001d02;
}

.multiselect__tags {
    width: 100%;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.25);
    border: 0;
    border-radius: 0;
    padding: 0 80px 0 2rem;
    font-size: inherit;
    cursor: pointer;
}

.multiselect__single,
.multiselect__placeholder {
    @apply font-heading text-sm tracking-medium font-semibold uppercase;
    @apply text-white;

    margin-bottom: 0;
    padding: 0;
    font-size: inherit;
    font-size: 12px;
    line-height: 1;
    min-height: unset;
    background-color: transparent;
}

.multiselect__select {
    height: 100%;
    width: 80px;
    border-left: 1px solid rgba(255, 255, 255, 0.25);

    &:before {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='9' viewBox='0 0 14 9' fill='none'%3E%3Cpath d='M13 1L7 7L1 0.999999' stroke='white' stroke-width='2'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        border: 0;
        display: block;
        width: 18px;
        height: 9px;
        position: absolute;
        top: 50%;
        right: 2rem;
        margin-top: -4.5px;
        transition: transform 0.2s ease;
    }
}

.multiselect--active .multiselect__select {
    transform: none;

    &:before {
        transform: rotate(180deg);
    }
}

.multiselect__option {
    display: flex;
    align-items: center;
    height: 88px;
    padding: 0 2rem;
    color: #5d83bf !important;

    @apply font-heading text-sm tracking-medium font-semibold uppercase;
    @apply text-white;
}

.multiselect__option--highlight {
    background-color: #5d83bf !important;
    color: #fff !important;
}

.multiselect__option--selected {
    background: rgba(78, 86, 43, 0.2);
    color: #fff !important;
}

.multiselect__content-wrapper {
    min-width: 100%;
    width: 236px;
    border: 0;
    overflow-x: hidden;
}

.caret {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
}
</style>
